import { connect } from 'react-redux';
import { 
	getFavoritesAction,
	closeModalAction,
	adjustUIOnPageLoadAction,
	completedAdjustWindowOnPageLoadAction,
	searchFlickrAction
} from '../flickr-redux/actions';
import Gallery from './Gallery';

const mapStateToProps = (state) => {
	return {
		photos: state.photos.photos,
		currentPage: state.photos.page,
		totalPages: state.photos.totalPages,
		searchQuery: state.search.searchQuery,
		favoredPhotos: state.photos.favorites,
		picCols: state.windowState.picCols
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		initializeFavorites: () => {
			dispatch(getFavoritesAction())
		},
		dispatchCloseModal: () => {
			dispatch(closeModalAction())
		},
		dispatchAdjustUI: () => {
			dispatch(adjustUIOnPageLoadAction())
		},
		dispatchCompletedAdjustUI: () => {
			dispatch(completedAdjustWindowOnPageLoadAction())
		},
		loadMorePhotos: (searchQuery, page) => {
			dispatch(searchFlickrAction(searchQuery, page));
		}
	}
}

const GalleryContainer = connect(mapStateToProps, mapDispatchToProps)(Gallery);
export default GalleryContainer;



/** WEBPACK FOOTER **
 ** ./src/gallery/GalleryContainer.js
 **/